import { render, staticRenderFns } from "./WidgetKeyResultDetails.vue?vue&type=template&id=491d7012&"
import script from "./WidgetKeyResultDetails.vue?vue&type=script&lang=js&"
export * from "./WidgetKeyResultDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports